import React from 'react';
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
//@ts-ignore
import ShowMoreText from 'react-show-more-text';

import { ITour } from '../../../store'

interface ITourProps {
    tour: ITour
    language: string
}

// Gol de la indieni
export const Tour: React.FC<ITourProps> = ({ language, tour }) => {
    let sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    };
    const countryBreadcrumbLink = (
        <Link to={{
            pathname: `/${language}/${tour.country.slug}`,
            state: {
                country: tour.country
            }
        }}>
        {tour.country.title}
        </Link>
    )
    const regionBreadcrumbLink = (
        <Link to={{
            pathname: `/${language}/${tour.country.slug}/${tour.location.regionSlug}`,
            state: {
                country: tour.country,
                location: tour.location,
                filterByRegion: true
            }
        }}>
        {tour.location.region}
        </Link>
    )
    const cityBreadcrumbLink = (
        <Link to={{
            pathname: `/${language}/${tour.country.slug}/${tour.location.regionSlug}/${tour.location.citySlug}`,
            state: {
                country: tour.country,
                location: tour.location
            }
        }}>
        {tour.location.city}
        </Link>
    )

    return (
        <>
            <iframe className="virtual-tour-iframe" title="Main Virtual Tour" src={`https://${language}.360tourist.net/view-tour/${tour.id}/${language}`} frameBorder={0} allowFullScreen></iframe>
            {/* {Content.map(item => item.title)} */}
            {/* <VideoBanner /> */}
            <div className="row m-t30">
                <div className="columns medium-12">
                    <p className="breadcrumbs">
                        Home > {tour.country.continentName} > {countryBreadcrumbLink} > {regionBreadcrumbLink} > {cityBreadcrumbLink}
                    </p>
                    <div className="tour-header">
                        <div className="row">
                            <div className="columns medium-7">
                                <h4>
                                    {tour && tour.title}
                                </h4>
                                {/* Offenburg, Black Forest, Germany */}
                                <p className="tour-address"><img src="/images/icons/icon-location.png" alt="" /> <span>{tour.location.city}, {tour.location.region}, {tour.country.title}</span></p>
                            </div>
                            <div className="columns medium-5 text-right">
                                <div className="rate-us">
                                    <span className="rating">
                                        4.5
                                    </span>
                                    <span>
                                        <small>&lt;&lt; Click to rate</small>
                                        <div className="rate-us-buttons">
                                            <button className="active"></button>
                                            <button className="active"></button>
                                            <button className="active"></button>
                                            <button className=""></button>
                                            <button className=""></button>
                                        </div>
                                    </span>
                                </div>
                                <button className="cta">
                                    <img src="/images/icons/icon-share.png" alt="Share" /> Share
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="tour-description">
                        <ShowMoreText
                            lines={3}
                            more='Show more'
                            less='Show less'
                            anchorClass=''
                        >
                            <div dangerouslySetInnerHTML={{ __html: tour.description}}/>
                        </ShowMoreText>
                    </div>
                    <h4>Social Connect</h4>
                    <ul className="small-block-grid-3 social-connect">
                        <li>
                            <button className="btn-facebook active">
                                <span>Facebook</span>
                            </button>
                        </li>
                        <li>
                            <button className="btn-instagram">
                                <span>Instagram</span>
                            </button>
                        </li>
                        <li>
                            <button className="btn-twitter">
                                <span>Twitter</span>
                            </button>
                        </li>
                    </ul>
                    <div className="row m-t10">
                        <div className="columns medium-7">
                            <img src="/images/tour-detail-image.jpg" alt="tour detail" />
                        </div>
                        <div className="columns medium-5">
                            <div className="social-box">
                                <div className="social-heading clearfix">
                                    <span className="social-logo" style={{ backgroundImage: 'url(/images/logo/logo.jpg)' }}></span>
                                    <button className="cta cta-small fr">Like</button>
                                    <h6>360 Tourist<br />
                                        <small>23hrs</small>
                                    </h6>

                                </div>
                                <p>Ever wondered how to make more time for cozy life moments? Look to the Danish art of “hygge” (coziness) and experience it in its truest form in this Copenhagen home. Don’t forget to add good food, drink and company. </p>
                                <div className="social-comments">
                                    <h6>2 Comments</h6>
                                    <textarea placeholder="Add a comment..."></textarea>
                                    <div className="social-comments-footer">
                                        <input type="checkbox" name="post_facebook" />
                                        <small>Also Post on Facebook </small>
                                        <button className="cta cta-small fr">Post</button>
                                    </div>
                                    <ul className="comment-list">
                                        <li>
                                            <img src="/images/icons/icon-user.jpg" alt="MP" />
                                            <p className="comment-title">
                                                Test Test
                                            </p>
                                            <p>Ever wondered how to make more time for cozy life moments? Look to the Danish art of “hygge”</p>
                                            <span className="comment-footer">
                                                <button>Like</button> - <button>Reply</button> - <button>Mark as spam</button> - 1y
                                            </span>
                                        </li>
                                        <li>
                                            <img src="/images/icons/icon-user.jpg" alt="MP" />
                                            <p className="comment-title">
                                                Test Test
                                            </p>
                                            <p>Ever wondered how to make more time for cozy life moments? Look to the Danish art of “hygge”</p>
                                            <span className="comment-footer">
                                                <button>Like</button> - <button>Reply</button> - <button>Mark as spam</button> - 1y
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <section className="section-review">
                <div className="row">
                    <div className="columns medium-12">
                        <h4>Black Forest Radio traveller reviews</h4>
                        <ul>
                            <li>
                                <span>
                                    <img src="/images/icons/user-avatar.png" alt="avatar" />
                                </span>
                                <small>Oleg Tumakov</small>
                                <p>
                                    <strong>wow!!</strong><br />
                                    Follow us on a virtual tour through the studio of the Black Forest Radio in Offenburg. The official holiday radio for the holiday region Black Forest opened for us exclusively his rooms to give his listeners a very private insight. Classic hits and super oldies digital or
via antenna. <a href="/">Read More...</a>
                                </p>
                            </li>
                            <li>
                                <span>
                                    <img src="/images/icons/user-avatar.png" alt="avatar" />
                                </span>
                                <small>Oleg Tumakov</small>
                                <p>
                                    <strong>wow!!</strong><br />
                                    Follow us on a virtual tour through the studio of the Black Forest Radio in Offenburg. The official holiday radio for the holiday region Black Forest opened for us exclusively his rooms to give his listeners a very private insight. Classic hits and super oldies digital or
via antenna. <a href="/">Read More...</a>
                                </p>
                            </li>
                        </ul>
                        <div className="text-center">
                            <button className="cta">Write a Review</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-explore">
                <div className="row">
                    <div className="columns medium-12">
                        <h4 className="m-t0">People who viewed these tour also explored</h4>

                        <Slider {...sliderSettings} className="medium-block-grid-4 explore-list nearby-carousel">

                            <div className="item-wrapper">
                                <Link to="/inner-page" style={{ backgroundImage: 'url(/images/coliseum-italy.jpg)' }}>
                                    <span>
                                        Fundorena, Feldberg, Germany
                                            <small>Lorem ipsum dolor sit amet, con...</small>
                                    </span>
                                </Link>
                                <button className="quick-tour">
                                    <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                                </button>
                            </div>

                            <div className="item-wrapper">
                                <Link to="/inner-page" style={{ backgroundImage: 'url(/images/coliseum-italy.jpg)' }}>
                                    <span>
                                        Fundorena, Feldberg, Germany
                                            <small>Lorem ipsum dolor sit amet, con...</small>
                                    </span>
                                </Link>
                                <button className="quick-tour">
                                    <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                                </button>
                            </div>

                            <div className="item-wrapper">
                                <Link to="/inner-page" style={{ backgroundImage: 'url(/images/coliseum-italy.jpg)' }}>
                                    <span>
                                        Fundorena, Feldberg, Germany
                                            <small>Lorem ipsum dolor sit amet, con...</small>
                                    </span>
                                </Link>
                                <button className="quick-tour">
                                    <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                                </button>
                            </div>

                            <div className="item-wrapper">
                                <Link to="/inner-page" style={{ backgroundImage: 'url(/images/coliseum-italy.jpg)' }}>
                                    <span>
                                        Fundorena, Feldberg, Germany
                                            <small>Lorem ipsum dolor sit amet, con...</small>
                                    </span>
                                </Link>
                                <button className="quick-tour">
                                    <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                                </button>
                            </div>

                            <div className="item-wrapper">
                                <Link to="/inner-page" style={{ backgroundImage: 'url(/images/coliseum-italy.jpg)' }}>
                                    <span>
                                        Fundorena, Feldberg, Germany
                                            <small>Lorem ipsum dolor sit amet, con...</small>
                                    </span>
                                </Link>
                                <button className="quick-tour">
                                    <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                                </button>
                            </div>

                            <div className="item-wrapper">
                                <Link to="/inner-page" style={{ backgroundImage: 'url(/images/coliseum-italy.jpg)' }}>
                                    <span>
                                        Fundorena, Feldberg, Germany
                                            <small>Lorem ipsum dolor sit amet, con...</small>
                                    </span>
                                </Link>
                                <button className="quick-tour">
                                    <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                                </button>
                            </div>

                            <div className="item-wrapper">
                                <Link to="/inner-page" style={{ backgroundImage: 'url(/images/coliseum-italy.jpg)' }}>
                                    <span>
                                        Fundorena, Feldberg, Germany
                                            <small>Lorem ipsum dolor sit amet, con...</small>
                                    </span>
                                </Link>
                                <button className="quick-tour">
                                    <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                                </button>
                            </div>

                        </Slider>
                    </div>
                </div>
            </section>
        </>
    );
}

// const Content = [
//     {
//         adds: false,
//         imagePath: '/images/luptatum-switzerland.jpg',
//         title: 'Biohof Herrenweg, Schilta...',
//         subTitle: 'Lorem ipsum dolor sit amet',

//     },
//     {
//         adds: false,
//         imagePath: '/images/coliseum-italy.jpg',
//         title: 'Leisure and sports center...',
//         subTitle: 'Lorem ipsum dolor sit amet',

//     },
//     {
//         adds: false,
//         imagePath: '/images/praesent-luptatum-china.jpg',
//         title: 'Praesent Luptatum',
//         subTitle: 'Lorem ipsum dolor sit amet',

//     },
//     {
//         adds: false,
//         imagePath: '/images/blanditcanada.jpg',
//         title: 'Biohof Herrenweg, Schilta...',
//         subTitle: 'Lorem ipsum dolor sit ame',

//     },
//     {
//         adds: false,
//         imagePath: '/images/constanta-la-reunion.jpg',
//         title: 'Constanta, La Reunion',
//         subTitle: 'Lorem ipsum dolor sit amet',

//     },
//     {
//         adds: false,
//         imagePath: '/images/blandit-praesen-andorra.jpg',
//         title: 'Blandit Praesent, Andorra',
//         subTitle: 'Lorem ipsum dolor sit ame',

//     },
//     {
//         adds: false,
//         imagePath: '/images/sighisoara-romania.jpg',
//         title: 'Sighisoara, Romania',
//         subTitle: 'Lorem ipsum dolor ',

//     }
// ]
